module.exports = __webpack_public_path__ + "img/tarot-major-arcana-17.49f7e5a3.png";